<template>
  <b-card
    v-if="chartData"
    class="card-tiny-line-stats"
    body-class="pb-50"
  >
    <h6 class="mb-2">
      Perkembangan jumlah produk
    </h6>
    <!-- chart -->
    <vue-apex-charts
      height="100"
      :options="chartOptions"
      :series="[{data: chartData}]"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

const $trackBgColor = '#EBEBEB'

export default {
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {

      chartOptions: {
        chart: {
          type: 'line',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        grid: {
          borderColor: $trackBgColor,
          strokeDashArray: 5,
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: false,
            },
          },
          padding: {
            top: -20,
            bottom: -10,
          },
        },
        stroke: {
          width: 3,
        },
        colors: [$themeColors.primary],
        markers: {
          size: 2,
          colors: $themeColors.primary,
          strokeColors: $themeColors.primary,
          strokeWidth: 2,
          strokeOpacity: 1,
          strokeDashArray: 0,
          fillOpacity: 1,
          shape: 'circle',
          radius: 2,
          hover: {
            size: 3,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          x: {
            // show: false,
          },
          y: {
            title: {
              formatter: () => 'Jumlah Produk',
            },
            formatter(value) {
              return value
            },
          },
          z: {
            formatter: () => '',
            title: '',
          },
        },
      },

    }
  },
}
</script>
